let catalogoJS = [];

document.addEventListener("DOMContentLoaded", async () => {
  catalogoJS = await getCatalogo();
  console.log(catalogoJS);
  // Render all products when the page loads
  renderProductos(catalogoJS);
  
  // Add event listener for search input
  document
    .getElementById("search-input-catalogo")
    .addEventListener("input", (e) => {
      const textoBuscado = normalizarCadena(e.target.value);

      // If search is empty, show all products
      if (!textoBuscado) {
        renderProductos(catalogoJS);
        return;
      }

      // Filter products by name and content
      const productosFiltrados = catalogoJS.filter((producto) => {
        const nombre = normalizarCadena(producto.nombre || "");
        const contenido = normalizarCadena(producto.contenido || "");
        
        // Split search text into words for better matching
        const palabras = textoBuscado.split(/\s+/).filter(palabra => palabra.length > 0);
        
        // Check if all search words are found in either name or content
        return palabras.every(palabra => 
          nombre.includes(palabra) || contenido.includes(palabra)
        );
      });

      // If no products match, show warning
      if (productosFiltrados.length === 0) {
        Swal.fire({
          icon: "warning",
          title: "Sin coincidencias",
          text: "No se encontraron productos con esa búsqueda",
          timer: 2000,
          showConfirmButton: false,
        });
        return;
      }

      // Render filtered products
      renderProductos(productosFiltrados);
    });
});

async function getCatalogo() {
  try {
    const response = await fetch(`${baseurl}/obtener/catalogo`, {
      method: "GET",
    });
    const data = await response.json();

    if (!data) {
      throw new Error("No se recibieron datos del servidor");
    }
    return data;
  } catch (error) {
    // Si usas SweetAlert2:
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Hubo un problema al obtener el catálogo de productos",
      timer: 3000,
      showConfirmButton: false,
      didClose: () => {
        // Redireccionar después de que se cierre la alerta
        window.location.href = "/";
      },
    });
    throw error; // Para que se propague el error
  }
}

/**
 * Normaliza una cadena quitando acentos y pasando a minúsculas
 */
function normalizarCadena(cadena = "") {
  let texto = cadena.toLowerCase();
  // Quitar acentos
  texto = texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  return texto;
}

/**
 * Renderiza los productos en el DOM
 */
async function  renderProductos(productos) {
  // Contenedor principal donde se mostrarán los productos
  const contenedorCatalogo = document.getElementById("catalogo");
  contenedorCatalogo.innerHTML = ""; // Limpia el contenido previo

  // Obtenemos el carrito desde localStorage
  let carrito = await get_carrito();
  console.log("Carrito obtenido:", carrito);
  

  // Obtenemos un array con todos los producto_id que están en el carrito
  let idsEnCarrito = [];
  if (carrito && carrito.productos && Array.isArray(carrito.productos)) {
    idsEnCarrito = carrito.productos.map((item) => item.id);
  }

  // Recorremos el array de productos y creamos el HTML de cada uno
  productos.forEach((producto) => {
    const productoDiv = document.createElement("div");
    productoDiv.classList.add("inicio_producto");

    // Verificamos si este producto está en el carrito
    const estaEnCarrito = idsEnCarrito.includes(producto.id);

    // Definimos botón e ícono según exista o no en el carrito
    let botonCarritoHtml = "";
    if (estaEnCarrito) {
      botonCarritoHtml = `
          <button 
            class="inicio_boton-carrito en-carrito"
            id="${producto.id}"
            onclick="event.stopPropagation(); controlBtn(this)"
            data-accion="1"
          >
            <i class="fa-solid fa-ban"></i>
            Quitar del carrito
          </button>`;
    } else {
      botonCarritoHtml = `
          <button 
            class="inicio_boton-carrito"
            id="${producto.id}"
            onclick="event.stopPropagation(); controlBtn(this)"
            data-accion="0"
          >
            <i class="fa-solid fa-bag-shopping"></i>
            Agregar al Carrito
          </button>`;
    }

    // Construimos el HTML del producto con la nueva estructura moderna
    productoDiv.innerHTML = `
        <div class="inicio_producto-imagen-container">
          <img 
            src="${baseurl}/build/img/sucursales/${producto.sucursal}/${producto.id}/${producto.imagen_1}" 
            alt="${producto.nombre}"
            loading="lazy"
            onload="this.classList.add('loaded'); this.parentElement.classList.add('loaded');"
            onerror="this.classList.add('loaded'); this.parentElement.classList.add('loaded');"
          />
        </div>
        <div class="inicio_info-producto">
          <h3 class="inicio_nombre-producto">${producto.nombre}</h3>
          <div class="inicio_precio-container">
            <div class="inicio_precio">${producto.precio}</div>
          </div>
          <div class="inicio_acciones-container">
            <a 
              href="${baseurl}/contenido?sucursal=${producto.sucursal}&id=${producto.id}" 
              class="inicio_boton-ver-contenido"
              onclick="event.stopPropagation()"
            >
              <i class="fas fa-eye"></i>
              Ver contenido
            </a>
            ${botonCarritoHtml}
          </div>
        </div>
      `;

    // Agregar evento click al card completo para ir a ver contenido
    productoDiv.addEventListener('click', function(e) {
      // Solo redirigir si el click no fue en un botón
      if (!e.target.closest('button') && !e.target.closest('a')) {
        window.location.href = `${baseurl}/contenido?sucursal=${producto.sucursal}&id=${producto.id}`;
      }
    });

    // Agregar clase para indicar que es clickeable
    productoDiv.style.cursor = 'pointer';

    // Agregar animación escalonada
    productoDiv.style.animationDelay = `${Math.min(productos.indexOf(producto) * 0.1, 1)}s`;

    // Lo agregamos al contenedor
    contenedorCatalogo.appendChild(productoDiv);
  });

  // Función para aplicar animaciones escalonadas
  function aplicarAnimacionesEscalonadas() {
    const productos = document.querySelectorAll('.inicio_producto');
    productos.forEach((producto, index) => {
      producto.style.animationDelay = `${index * 0.1}s`;
      producto.style.opacity = '0';
      producto.style.transform = 'translateY(30px)';
      
      // Forzar reflow y aplicar animación
      setTimeout(() => {
        producto.style.animation = 'fadeInUp 0.6s ease-out forwards';
      }, 50);
    });
  }

  // Llamar la función después de renderizar productos
  aplicarAnimacionesEscalonadas();
}
